export const NAMESPACE = 'medicines';
